import { render } from "./AddBreeder.vue?vue&type=template&id=36abe5a4&scoped=true"
import script from "./AddBreeder.vue?vue&type=script&lang=js"
export * from "./AddBreeder.vue?vue&type=script&lang=js"

import "./AddBreeder.vue?vue&type=style&index=0&id=36abe5a4&scoped=true&lang=css"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36abe5a4"]])

export default __exports__